<template>
    <el-form class="divfrom" :inline="true" label-position="right" label-width="120px">
        <el-form-item label="学校编码/名称：">
            <el-input v-model="request.model.LoginName" placeholder="" />
        </el-form-item>
        <el-form-item label="状态：">
            <el-radio-group v-model="request.model.SexName">
                <el-radio label="全部">全部</el-radio>
                <el-radio label="1">待审核</el-radio>
                <el-radio label="2">审核通过</el-radio>
                <el-radio label="3">审核未通过</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-button class="but" type="primary">查询</el-button>
    </el-form>

    <el-table class="w-full " :data="tableData.Models" style="width: 100%" :fit="false">
        <el-table-column prop="LoginName" label="学校编码" width="300" show-overflow-tooltip />
        <el-table-column prop="UserName" label="学校名称" width="300" show-overflow-tooltip />
        <el-table-column label="文件下载" width="200">
            <!-- <template #default="scope">
                <span v-if="scope.row.Status != 0">
                    <a href="">点击下载</a>
                </span>
            </template> -->
        </el-table-column>

        <el-table-column label="状态" width="150">
            <template #default="scope">
                <span v-if="scope.row.Status == 1">
                    <img src="../../../content/img/wait.png" />
                </span>
                <span v-else-if="scope.row.Status == 2">
                    <img src="../../../content/img/through.png" />
                </span>
                <span v-else-if="scope.row.Status == 3">
                    <img src="../../../content/img/notOver.png" />
                </span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
            <template #default="scope">
                <el-button link type="primary" size="small" @click="EditClick(scope.row.Id)">审核</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="demo-pagination-block">
        <br />
        <el-pagination :locale="zhCn" v-model:currentPage="request.PageIndex" v-model:page-size="request.PageSize"
            :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next" :total="tableData.Total"
            @size-change="Seach" @current-change="Seach">
        </el-pagination>
    </div>
</template>
<script>
import { reactive } from 'vue'
export default {
    mounted() {

    }, data() {
        const request = reactive({
            PageIndex: '1',
            PageSize: '10',
            model:
            {
            }

        });
        const tableData = reactive({
            Models: [{
                LoginName: '100001',
                UserName: '测试学校数据',
                Status: 1

            }, {
                LoginName: '100002',
                UserName: '测试学校数据2',
                Status: 2

            }, {
                LoginName: '100003',
                UserName: '测试学校数据3',
                Status: 3

            }],
            Total: 3,
        });
        return {
            request,
            tableData,
        }
    }, deactivated() {

    }
};
</script>
<style scoped>
.divfrom {
    height: 80px;
}

.but {
    margin-left: 50px;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
    border-color: #409eff;
    background: #409eff;
}

:deep(.el-radio__input.is-checked + .el-radio__label) {
    color: #409eff;
}
</style>